import Chatboticon from "./Chatboticon";
import ReactMarkdown from "react-markdown";

const ChatMessage = ({ chat }) => {
    return (
        !chat.hideInChat && (
            <div className={`message ${chat.role === "model" ? 'bot' : 'user'}-message ${chat.isError ? "error" : ""}`}>
                {chat.role === "model" && <Chatboticon />}
                
                {/* We wrap the text and the action button in a container */}
                <div className="message-content-wrapper">
                    <div className="message-text">
                        <ReactMarkdown>{chat.text}</ReactMarkdown>
                    </div>
                    
                    {/* Conditionally render the button if the API offline logic passed an action */}
                    {chat.action && (
                        <a href={chat.action.url} target="_blank" rel="noopener noreferrer" className="chat-action-btn">
                            {chat.action.text}
                            <span className="material-symbols-rounded">arrow_right_alt</span>
                        </a>
                    )}
                </div>
            </div>
        )
    );
};

export default ChatMessage;